import { useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { Container } from '@mui/material';
import { ExamFormValues, Loader, useCourse, usePartner, useToast } from '@shared';
import { RouteEnum, examsApi } from 'App';
import { Form } from '../Form';

type TypeProps = {
  partner: string;
  course: string;
  rootPath: RouteEnum;
};

const initialValues: ExamFormValues = {
  name: '',
  start: null,
  end: null,
  url: '',
  password: '',
  proctoringOption: '',
  secureBrowserSettings: {
    enabled: false,
    disableNavigation: false,
    disablePrintScreen: false,
    disableCopyPaste: false,
    forceFullScreen: false,
    enableWhitelistedUrls: false,
    whitelistedUrls: '',
  },
};

export const Create = ({ partner, course, rootPath }: TypeProps) => {
  const navigate = useNavigate();
  const toast = useToast();

  const onExit = () => navigate(rootPath);

  const { safeBrowserEnabled, isLoading: isLoadingPartner } = usePartner({ partner });
  const courseName = useCourse({ partner, course });

  const { mutate: createExam, isLoading } = useMutation({
    mutationFn: (data: ExamFormValues) => examsApi.addExam(partner, course, data),
    onSuccess: () => {
      toast.success('Exam has been created');
      onExit();
    },
  });

  const handleSubmit = (values: ExamFormValues) => {
    createExam(values);
  };

  if (isLoadingPartner) {
    return <Loader />;
  }

  return (
    <Container component='article' maxWidth='sm'>
      <Form
        courseName={courseName}
        safeBrowserEnabled={safeBrowserEnabled}
        onSubmit={handleSubmit}
        initialValues={initialValues}
        isLoading={isLoading}
        onExit={onExit}
        title='Create Exam'
        submitButtonLabel='Finish'
      />
    </Container>
  );
};
